/**
 * After JSON.parse (axios), Mongo extended JSON decimals look like
 * { $numberDecimal: "99.5" }. React cannot render those as children.
 */
function unwrapNumberDecimal(obj) {
  if (obj == null || typeof obj !== "object") return null;
  if (!Object.prototype.hasOwnProperty.call(obj, "$numberDecimal")) return null;
  const raw = obj.$numberDecimal;
  const n = typeof raw === "string" ? parseFloat(raw) : Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function normalizeMongoDecimals(value) {
  if (value == null) return value;
  if (typeof value === "number" || typeof value === "boolean") return value;
  if (typeof value === "string") return value;
  if (Array.isArray(value)) {
    return value.map(normalizeMongoDecimals);
  }
  if (typeof value === "object") {
    const unwrapped = unwrapNumberDecimal(value);
    if (unwrapped !== null) return unwrapped;
    const out = {};
    for (const key of Object.keys(value)) {
      out[key] = normalizeMongoDecimals(value[key]);
    }
    return out;
  }
  return value;
}
